/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ErrorCostRateDto } from '../../models/error-cost-rate-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface UpdateErrorCostRate$Params {
  body: ErrorCostRateDto;
}

export function updateErrorCostRate(
  http: HttpClient,
  rootUrl: string,
  params: UpdateErrorCostRate$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ErrorCostRateDto>> {
  const rb = new RequestBuilder(rootUrl, updateErrorCostRate.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ErrorCostRateDto>;
    }),
  );
}

updateErrorCostRate.PATH = '/service/v1/afterSales/errorCostRates';
